export default __webpack_public_path__ + "static/apple-store-black-button-eb56a4909dc83fd521a885396d8ed831.svg";